import cn from 'classnames';

import styles from '../../styles.module.scss';
import { useRedeemCouponContext, VARIANTS } from '../context';

import containerStyles from './styles.module.scss';

export function Content({ children }) {
  const { variant, halfWidth } = useRedeemCouponContext();

  const className =
    variant === VARIANTS.large ? cn(styles.codeColumn, { [styles.halfWidth]: halfWidth }) : '';

  return <div className={cn(className, containerStyles.content)}>{children}</div>;
}
